import React from "react";
import { Route } from "react-router-dom";
import { HeaderContainer } from "src/containers/HeaderContainer";
import { SidebarContainer } from "src/containers/SidebarContainer";
import { NoPrint } from "react-easy-print";

/**
 * Default app layout
 * Wraps the given react component between a header and a footer
 */
export const MainLayout = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <div className="d-flex flex-column">
          <div>
            <NoPrint force={true}>
              <HeaderContainer
                projectId={parseInt(matchProps.match.params.id, 10)}
                prestationId={parseInt(
                  matchProps.match.params.prestationId,
                  10
                )}
                proposalUuid={matchProps.match.params.proposalUuid}
              />
            </NoPrint>
          </div>
          <div className="d-flex flex-1">
            <NoPrint force={true}>
              <SidebarContainer
                projectId={parseInt(matchProps.match.params.id, 10)}
                prestationId={parseInt(
                  matchProps.match.params.prestationId,
                  10
                )}
                currentLocation={matchProps.location.pathname}
              />
            </NoPrint>
            <div className="flex-grow-1 p-5">
              <Component {...matchProps} />
            </div>
          </div>
        </div>
      )}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/MainLayout.tsx